import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic-policies',
  templateUrl: './academic-policies.component.html',
  styleUrls: ['./academic-policies.component.scss']
})
export class AcademicPoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
